export default {
  enabled: true,
  freezeInverval: 3,
  freezeSensitivity: 0.0001,
  port: 5000,
  silenceInterval: 3,
  silenceSensitivity: 0.0001,
};
